// @flow
import React from 'react'
import PropTypes from 'prop-types';
import Switch from 'react-bootstrap-switch';

import _ from 'lodash';
import I18n from 'PMT/i18n/I18n';

import FormGroupView from 'PMT/components/form/FormGroupView';

const PaymentMethodsAllowed = ({ modeSettings, restaurant, onClick, disabled = false }) => {

  return (
    <FormGroupView>
      <FormGroupView.Label>
        {I18n.tr('order.settings.payment_methods_allowed.label')}
      </FormGroupView.Label>
      <FormGroupView.Content>
        <FormGroupView>
          <FormGroupView.Label>
            {I18n.tr('order.settings.payment_methods_allowed.irl')}
          </FormGroupView.Label>
          <FormGroupView.Content>
            <Switch
              bsSize="mini"
              value={modeSettings.havePaymentMethodAllowedIrl()}
              onChange={() => onClick(modeSettings.orderPaymentMethodsAllowed.IRL)}
              disabled={disabled}
            />
          </FormGroupView.Content>
        </FormGroupView>
        <FormGroupView>
          <FormGroupView.Label>
            {I18n.tr('order.settings.payment_methods_allowed.cb')}
          </FormGroupView.Label>
          <FormGroupView.Content>
            <Switch
              bsSize="mini"
              value={modeSettings.havePaymentMethodAllowedCreditCard()}
              onChange={() => onClick(modeSettings.orderPaymentMethodsAllowed.CREDIT_CARD)}
              disabled={disabled}
            />
          </FormGroupView.Content>
        </FormGroupView>

        {restaurant.psp === 'PAYGREEN' && (
          <FormGroupView>
            <FormGroupView.Label>
              {I18n.tr('order.settings.payment_methods_allowed.trd')}
            </FormGroupView.Label>
            <FormGroupView.Content>
              <Switch
                bsSize="mini"
                value={modeSettings.havePaymentMethodAllowedTRD()}
                onChange={() => onClick(modeSettings.orderPaymentMethodsAllowed.TRD)}
                disabled={disabled}
              />
            </FormGroupView.Content>
          </FormGroupView>
        )}
        <FormGroupView>
          <FormGroupView.Label>
            {I18n.tr('order.settings.payment_methods_allowed.user_account')}
          </FormGroupView.Label>
          <FormGroupView.Content>
            <Switch
              bsSize="mini"
              value={modeSettings.havePaymentMethodAllowedUserAccount()}
              onChange={() => onClick(modeSettings.orderPaymentMethodsAllowed.USER_ACCOUNT)}
              disabled={disabled}
            />
          </FormGroupView.Content>
        </FormGroupView>
      </FormGroupView.Content>
    </FormGroupView>
  )
}

PaymentMethodsAllowed.propTypes = {
  onClick: PropTypes.func.isRequired,
  modeSettings: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
}

export default PaymentMethodsAllowed
